import { THREE_PS_TABLE } from "./threePsTable.constants"

export const getThreePsTableConstant = (key: string) => {
    return THREE_PS_TABLE[key.toLowerCase()] || THREE_PS_TABLE['default']
}


export const pluralize = (count: number, word: string) => `${count} ${word}${count !== 1 ? 's' : ''}`